import {
	AlertDialog,
	BlockWithError,
	BlockWithInfo,
	BlockWithLoading,
	CustomButton,
	CustomButtonWithCheckbox,
	CustomMultiSelect,
	CustomSelect,
	CustomTextfieldWithTouched,
	IconButton,
	TextfieldWithAutocomplete,
} from "@/ui";
import { FILTERS_LIST, SCHEDULER_PARAMS } from "./CallingLineParams.const";
import { ICallingLineParams, TinitialValues } from "./CallingLineParams.props";
import cn from "classnames";
import styles from "./CallingLineParams.module.scss";

import { Box, Slide } from "@mui/material";
import { CLS, SES } from "@/constants/accessRights";
import H3 from "@/ui/H3/H3";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { colorRed } from "@/constants/colors";
import NoticeSingleAction from "@/ui/NoticeSingleAction/NoticeSingleAction";
import { getDaysInMonth } from "@/helpers";
// import { ActionButton } from "./CallingLineParams.styles";
import { useCallingLineParams } from "./useCallingLineParams";
import { Hint } from "@/HOC";

const CallingLineParams = ({ showLogs, setShowParams, telegramChannelHint = "", voiceChannelHint = "" }: ICallingLineParams) => {
	const {
		formik,
		isLoading,
		callingListsData,
		localEndpointsData,
		// processData,
		currentChannel,
		currentCallingListId,
		autocompleteOptionsForSource,
		isSubmitting,
		showAlertDialog,
		setShowAlertDialog,
		showNotification,
		setShowNotification,
		snackbarMessage,
		currentCallingList,
		handleSubmitForm,
		refetchCallingLists,
		// handleStartCallingForCurrentList,
		// handleStopCallingForCurrentList,
		handleDeleteCallingList,
		toggleListActive,
		toggleAlert,
		warningCounter,
		timeintervalsList,
		endpointsList,
		robotList,
		translate,
		isAccess,
	} = useCallingLineParams();

	const closeHandler = (): void => {
		setShowParams(false);
	};
	if (isLoading) return <BlockWithLoading />;
	const robot =
		autocompleteOptionsForSource && autocompleteOptionsForSource.find((el) => el.value === formik.values.source)
			? autocompleteOptionsForSource.find((el) => el.value === formik.values.source)
			: { value: "", label: "" };
	return (
		<>
			<Slide direction="left" in={showLogs} mountOnEnter unmountOnExit>
				<div className={styles.modal} onMouseDown={closeHandler}>
					<div className={cn(styles.container)} onMouseDown={(e) => e.stopPropagation()}>
						<Hint hint={currentChannel === "telegram" ? telegramChannelHint : voiceChannelHint} position="left" offset={[0, -8]}>
							<section className={cn(styles["filter-section"])}>
								{callingListsData?.error === 1 || callingListsData === undefined || currentCallingList === undefined ? (
									<BlockWithError updateHandler={refetchCallingLists} style={{ margin: "auto" }} />
								) : (
									<>
										<p className={cn(styles["filter-section-additional-info"])}>
											{robot && robot.label ? <span>{`${translate("title_currentRobot")}: ${robot.label.split("(")[1].split(")")[0]} `}</span> : <span></span>}
											<span>
												{translate("title_communicationChannel")}:{" "}
												{callingListsData?.error === 1
													? ""
													: translate(`title_${callingListsData?.lists?.find?.((el) => el.id === currentCallingListId)?.channel ?? ""}`)}
											</span>
										</p>
										<div className={cn(styles["filter-section-container"])}>
											<div className={cn(styles["filter-section-inputs-list"])}>
												{callingListsData &&
													Array.isArray(callingListsData.lists) &&
													FILTERS_LIST.map((el) => {
														const currentList = callingListsData.lists.find((el) => el.id === currentCallingListId);
														return el.title === "source" && currentChannel === "voice" ? (
															<TextfieldWithAutocomplete
																freeSolo
																autocompleteOptionsWithId={autocompleteOptionsForSource ?? []}
																value={formik.values["source"]}
																setValues={formik.setValues}
																values={formik.values}
																onInputChange={(e) => {
																	if (e !== null) {
																		formik.handleChange(e);
																	}
																}}
																onChange={(e) => {
																	formik.handleChange(e);
																}}
																valueFrom="value"
																// onBlur={() => {
																// 	const options = robotList.data.map((robot) => robot.id);
																// 	const currentValue = formik.values.robotId;

																// 	// если текущее значение не найдено среди вариантов — откатываем
																// 	if (!options.includes(currentValue)) {
																// 		formik.setFieldValue("robotId", formik.initialValues.robotId);
																// 	}
																// }}
																disabled={!isAccess(CLS.LISTS_MODIFY) || !isAccess(SES.ROBOT_LIST)}
																name={"source"}
																label={translate(typeof el.label === "string" ? el.label : el.label[(currentList?.channel ?? "") as "voice" | "telegram"])}
																shrink={true}
															/>
														) : (
															el.channel.includes(currentChannel) && (
																<CustomTextfieldWithTouched
																	key={el.title}
																	type={el.title === "scheduler" ? "datetime-local" : el.type}
																	name={el.title}
																	sx={{ width: "100%", gridColumn: el.size }}
																	onChange={formik.handleChange}
																	multiline={el.title === "description" ? true : false}
																	minRows={el.title === "description" ? 2 : 1}
																	maxRows={el.title === "description" ? 2 : 1}
																	disabled={!isAccess(CLS.LISTS_MODIFY)}
																	label={translate(typeof el.label === "string" ? el.label : el.label[(currentList?.channel ?? "") as "voice" | "telegram"])}
																	value={formik.values[el.title as keyof TinitialValues]}
																	onBlur={formik.handleBlur}
																	min={0}
																	required={el.required}
																	error={Boolean(formik.errors[el.title as keyof TinitialValues])}
																	touched={Boolean(formik.touched[el.title as keyof TinitialValues])}
																/>
															)
														);
													})}
												{robotList.data && currentChannel === "telegram" && (
													<Box sx={{ gridColumn: "0 / 1" }}>
														<TextfieldWithAutocomplete
															autocompleteOptionsWithId={robotList.data.map((robot) => ({ value: robot.id, label: robot.name }))}
															value={formik.values.robotId}
															setValues={formik.setValues}
															values={formik.values}
															onChange={(e) => formik.handleChange(e)}
															onBlur={() => {
																const options = robotList.data.map((robot) => robot.id);
																const currentValue = formik.values.robotId;

																// если текущее значение не найдено среди вариантов — откатываем
																if (!options.includes(currentValue)) {
																	formik.setFieldValue("robotId", formik.initialValues.robotId);
																}
															}}
															disabled={!isAccess(CLS.LISTS_MODIFY) || !isAccess(SES.ROBOT_LIST)}
															name="robotId"
															label={translate("select_robot")}
														/>
													</Box>
												)}
												{localEndpointsData && currentChannel === "telegram" && (
													<Box sx={{ gridColumn: "-1 / 1" }}>
														<TextfieldWithAutocomplete
															autocompleteOptionsWithId={endpointsList}
															value={formik.values.endpointId}
															setValues={formik.setValues}
															values={formik.values}
															onChange={(e) => formik.handleChange(e)}
															onBlur={() => {
																const options = endpointsList.map((endpoint) => endpoint.value);
																const currentValue = formik.values.endpointId;

																// если текущее значение не найдено среди вариантов — откатываем
																if (!options.includes(currentValue)) {
																	formik.setFieldValue("endpointId", formik.initialValues.endpointId);
																}
															}}
															disabled={!isAccess(CLS.LISTS_MODIFY) || !isAccess(SES.ENDPOINT_LIST)}
															name="endpointId"
															label={translate("select_endpoint")}
														/>
													</Box>
												)}
											</div>

											{/* блок интервалов */}
											<CustomMultiSelect
												variantsList={
													timeintervalsList?.timeintervals?.map((el) => ({
														title: el.name,
														value: el.id,
													})) ?? []
												}
												label={translate("select_timeintervalsList")}
												setState={(val) => formik.setFieldValue(`timeintervals`, val)}
												values={formik.values.timeintervals}
												elementWidth="full"
												disabled={!isAccess(CLS.LISTS_MODIFY)}
												width={"auto"}
												height={33}
											/>

											{/* блок расписания */}
											<section className={cn(styles["scheduler-section"])}>
												<H3 className={styles.eventsTitle}>{translate(currentChannel === "telegram" ? "title_scheduleForTelegram" : "title_scheduleForVoice")}</H3>

												<div className={cn(styles["scheduler-list"])}>
													{formik.values.scheduler.length === 0 ? (
														<div className={cn(styles["scheduler-list-empty-container"])}>
															<BlockWithInfo title="title_emptyList" />
														</div>
													) : (
														formik.values.scheduler.map((_, idx) => (
															<div key={idx} className={cn(styles["scheduler-item"])}>
																<div className={cn(styles["scheduler-item-params"])}>
																	{SCHEDULER_PARAMS.map((el) => {
																		const field = el.label.split("_")[1] as keyof (typeof formik.values.scheduler)[number];

																		if (field === "hours" || field === "minutes") {
																			const { hours = "", minutes = "" } = formik.values.scheduler[idx] || {};
																			if (field === "minutes") {
																				return (
																					<CustomTextfieldWithTouched
																						key={el.label}
																						type="time"
																						label={translate("select_time")}
																						value={`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`}
																						disabled={!isAccess(CLS.LISTS_MODIFY)}
																						onChange={(e) => {
																							const [h, m] = e.target.value.split(":");
																							formik.setFieldValue(`scheduler[${idx}].hours`, h);
																							formik.setFieldValue(`scheduler[${idx}].minutes`, m);
																							formik.setFieldValue("isListActiveLocal", false);
																						}}
																						sx={{
																							mt: "4px",
																							"& input::-webkit-calendar-picker-indicator": {
																								display: "none",
																								WebkitAppearance: "none",
																							},
																						}}
																						height={33}
																					/>
																				);
																			}
																			return null;
																		}

																		const elIndex = el.variantsList.findIndex((variant) => variant.value === formik.values.scheduler[idx][field]);

																		if (field === "date") {
																			const currentMonth = formik.values.scheduler[idx].month;
																			const monthIndex = currentMonth === "*" ? 0 : Number(currentMonth);

																			const variantsList = [{ title: "*", value: "*" }, ...getDaysInMonth(monthIndex)];

																			const elIndex = variantsList.findIndex((v) => v.value === formik.values.scheduler[idx].date);

																			return (
																				<CustomSelect
																					key={el.label}
																					title={translate(el.title)}
																					label={translate(el.label)}
																					variantsList={variantsList}
																					disabled={!isAccess(CLS.LISTS_MODIFY)}
																					setState={(val) => {
																						formik.setFieldValue(`scheduler[${idx}].date`, val);
																						formik.setFieldValue("isListActiveLocal", false);
																					}}
																					valueIndex={elIndex === -1 ? 0 : elIndex}
																					height={33}
																				/>
																			);
																		}

																		return (
																			<CustomSelect
																				title={translate(el.title)}
																				variantsList={el.variantsList}
																				label={translate(el.label)}
																				disabled={!isAccess(CLS.LISTS_MODIFY)}
																				setState={(val) => {
																					formik.setFieldValue(`scheduler[${idx}].${field}`, val);
																					formik.setFieldValue("isListActiveLocal", false);
																				}}
																				valueIndex={elIndex === -1 ? 0 : elIndex}
																				key={el.label}
																				height={33}
																			/>
																		);
																	})}
																</div>
																{isAccess(CLS.LISTS_MODIFY) && (
																	<IconButton
																		onClick={() => {
																			const newScheduler = [...formik.values.scheduler];
																			newScheduler.splice(idx, 1);
																			formik.setFieldValue("scheduler", newScheduler);
																		}}
																		icon={faTrashCan}
																		iconColor={colorRed}
																		iconSize="sm"
																		title={translate("button_delete")}
																	/>
																)}
															</div>
														))
													)}
												</div>
												{isAccess(CLS.LISTS_MODIFY) && (
													<CustomButton
														variant="text"
														onClick={() => {
															formik.setFieldValue("scheduler", [...formik.values.scheduler, { minutes: "*", hours: "*", date: "*", month: "*", dayOfWeek: "*" }]);
															formik.setFieldValue("isListActiveLocal", false);
														}}
														sx={{ alignSelf: "center" }}
													>
														+ {translate("button_add")}
													</CustomButton>
												)}
												{isAccess(CLS.START) && (
													<div className={cn(styles["button-group"])}>
														{isAccess(CLS.SCHEDULER_GET) && (
															<CustomButtonWithCheckbox
																fullWidth
																onClick={toggleListActive}
																isActive={formik.values.isListActiveLocal}
																disabled={formik.values.scheduler.length === 0 || !isAccess([CLS.SCHEDULER_RESUME, CLS.SCHEDULER_PAUSE])}
																title={formik.values.isListActiveLocal ? translate("title_schedulerActive") : translate("title_schedulerInactive")}
															>
																{formik.values.isListActiveLocal ? translate("button_schedulerActive") : translate("button_schedulerInactive")}
															</CustomButtonWithCheckbox>
														)}
														{/* {processData && !processData.running ? (
														<ActionButton
															variant="outlined"
															onClick={handleStartCallingForCurrentList}
															disabled={currentCallingList?.items.length === 0 && !currentCallingList.autoload}
														>
															<span className={cn(styles["button-text"])}>{translate("button_runNow")}</span>
														</ActionButton>
													) : (
														<ActionButton variant="outlined" onClick={handleStopCallingForCurrentList} sx={{ fontSize: 11, width: "100%" }}>
															{translate("button_stop")}
														</ActionButton>
													)} */}
													</div>
												)}
											</section>
										</div>
										<div className={cn(styles["button-group"])} style={{ marginTop: "auto" }}>
											{isAccess(CLS.LISTS_DELETE) && (
												<CustomButton fullWidth onClick={() => setShowAlertDialog(true)} title={translate("button_deleteList")} color="error">
													{translate("button_delete")}
												</CustomButton>
											)}
											{isAccess(CLS.LISTS_MODIFY) && (
												<CustomButton fullWidth disabled={!formik.dirty || !formik.isValid || isSubmitting} onClick={handleSubmitForm}>
													{translate("button_save")}
												</CustomButton>
											)}
										</div>
									</>
								)}
							</section>
						</Hint>
						<div className={styles.tagClose} onClick={closeHandler}>
							{translate("button_close")}
						</div>
					</div>
				</div>
			</Slide>
			<NoticeSingleAction
				severity={
					snackbarMessage.toLowerCase().includes("fail") || snackbarMessage.toLowerCase().includes("ошибка") || snackbarMessage.toLowerCase().includes("error")
						? "error"
						: "info"
				}
				showNotification={showNotification}
				setShowNotification={setShowNotification}
				title={snackbarMessage}
			/>
			<AlertDialog
				showAlertDialog={warningCounter === 1 ? true : showAlertDialog}
				setShowAlertDialog={toggleAlert(warningCounter)}
				submitHandler={handleDeleteCallingList}
				title={translate("dialog_delete")}
				description={translate(warningCounter < 1 ? "dialog_deleteList" : "dialog_deleteListConfirmation")}
				isDisabled={isSubmitting}
			/>
		</>
	);
};

export default CallingLineParams;
